//import { lastIndexOf } from 'core-js/library/core/array';
import React, { useState } from 'react';
import Stage from './pipeline/stage/Stage';
import { GENERAL_ERROR_UPDATE_PAGE_MESSAGE } from '../../../../i18n/keyConstants';
import { useTranslation } from 'react-i18next';

/**
 * Pipeline stages in current pipeline. Saves onclick. Name displayed in cells.
 * - `PipelineStage`: `{string id, string pipelineId, string name, int order}`
 * @param {object} [pipelineStage] Initial value.
 * @param {bool} [dealStatus] null - open, true - won, false - lost.
 * @param {object} [stages] Selectable stages.
 * @param {function} [handleSave] [async (string lineId, string stageId) => {bool success, string message}].
 */

const EditablePipelineStage = ({ pipelineStage, pipelineStageHistory, dealStatus, pipelineStages, handleSave }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const statusClassName = dealStatus === true ? 'won' : dealStatus === false ? 'lost' : 'open';
    const selectedIndex = pipelineStages.findIndex((s) => s.id === pipelineStage.id);
    const { t } = useTranslation(['errorMessages']);

    const onClick = async (s) => {
        if (s.id === pipelineStage.id || isLoading) return;
        setIsLoading(true);
        const response = await handleSave(s);
        if (response.success) {
            await new Promise((r) => setTimeout(r, 400));
        } else {
            setErrorMessage(response.message && response.message.length ? response.message : t(GENERAL_ERROR_UPDATE_PAGE_MESSAGE));
        }
        setIsLoading(false);
    };

    const calcDays = (stageId) => {

        if (pipelineStageHistory.length === 0) {
            return null;
        }

        pipelineStageHistory.sort((a, b) => (a.date > b.date) ? 1 : ((b.date > a.date) ? -1 : 0))

        var indices = [];
        for (var post in pipelineStageHistory) {
            if (pipelineStageHistory[post].pipelineStageId === stageId) {
                indices.push(post);
            }
        }

        if (indices.length === 0) {
            return null;
        }
        
        var sumDays = 0;
        for (var i in indices) {
            i = parseInt(indices[i]);
            var startDate = new Date(Date.parse(pipelineStageHistory[i].date));
            var endDate = !pipelineStageHistory[i + 1] ? utcDate() : new Date(Date.parse(pipelineStageHistory[i + 1].date));
            const diffTime = Math.abs(endDate - startDate);
            sumDays = sumDays + diffTime / (1000 * 60 * 60 * 24);
        }

        return Math.floor(sumDays).toString() + " dagar";
    }

    const utcDate = () => {
        var date = new Date();
        var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();

        newDate.setHours(hours + offset);
        return newDate;
    }

    const secondaryStageContent = (id, name) => {
        return <div><div style={{ fontWeight: 500 }}>{name}</div>
            {(calcDays(id) ? < div style={{ fontWeight: 300 }} >
                Har varit h&auml;r i {calcDays(id)}</div >
                : <div style={{ fontWeight: 300 }}>Har &auml;nnu inte varit h&auml;r</div>)}</div>;
    }

    return (
        <div className='editable-pipeline-stage'>
            <div className={`pipeline-stages ${statusClassName} ${errorMessage && 'error'}`}>
                <ul>
                    {pipelineStages.map((s, i) => (
                        <Stage
                            key={s.id}
                            pipelineStage={s}
                            highlighted={i <= selectedIndex}
                            hasArrow={i < pipelineStages.length - 1}
                            onClick={() => onClick(s)}
                            stageContent={calcDays(s.id)}
                            secondaryStageContent={secondaryStageContent(s.id, s.name)}
                            isLoading={isLoading && s.id === pipelineStage.id}
                        />
                    ))}
                </ul>
            </div>
            {errorMessage && <div className='error-message'>{errorMessage}</div>}
        </div>
    );
};

export default EditablePipelineStage;
